import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Live from "@/pages/live/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Replay from "@/pages/replay/page";
import Analysis from "@/pages/analysis/page";
import About from "@/pages/about/page";
import Search from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/live",
    element: <Live />,
  },
  {
    path: "/category/:league",
    element: <Category />,
  },
  {
    path: "/detail/:matchId",
    element: <Detail />,
  },
  {
    path: "/replay",
    element: <Replay />,
  },
  {
    path: "/analysis",
    element: <Analysis />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;